export enum EventType {
  SourceStarted = "source_started",
  SourceStopped = "source_stopped",
  SourceUpdated = "source_updated",
  SourceMetadata = "source_metadata",
}
